<script>
  import { createEventDispatcher, onDestroy, onMount } from "svelte";

  export let content = "";

  const dispatch = createEventDispatcher();
  const listeners = new Map();
  let wrapper;

  onMount(() => {
    const els = Array.from(wrapper.querySelectorAll("[data-on]"));
    els.forEach(el => {
      const [eventData, handler] = el.dataset.on.split(":");
      const [event, ...modifiers] = eventData.split("|");

      listeners.set(el, {
        // eslint-disable-next-line consistent-return
        listener: (evt) => {
          if (modifiers.includes("self")) {
            if (evt.target !== el) {
              return false;
            }
          }

          if (modifiers.includes("preventDefault")) {
            evt.preventDefault();
          }

          if (modifiers.includes("stopPropagation")) {
            evt.stopPropagation();
          }

          dispatch(handler || event, { originalEvent: evt });
        },
        options: {
          once: modifiers.includes("once"),
          // eslint-disable-next-line no-nested-ternary
          passive: modifiers.includes("passive")
            ? true
            : modifiers.includes("nonpassive")
              ? false
              // eslint-disable-next-line no-undefined
              : undefined,
          useCapture: modifiers.includes("capture")
        },
        type: event
      });

      const {listener, options} = listeners.get(el);

      el.addEventListener(event, listener, options);
    });
  });

  onDestroy(() => {
    const els = Array.from(wrapper.querySelectorAll("[data-on]"));
    els.forEach(el => {
      const {listener, options, type} = listeners.get(el);
      el.removeEventListener(type, listener, options);
      listeners.delete(el);
    });
  });
</script>

{#if content}
  <div bind:this={wrapper}>
    {@html content}
  </div>
{/if}
